import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "../../style/customCentralProfileNew.css";
import "../../style/customresponsivefile.css"
import "../../style/designer-milling-responsive.css";
import { PredefinedWord } from "../../Routes/Predefined";
import { decodeToken } from "../../utils/auth";
import { apiAxios } from "../../utils/apiAxios";

const API_BASE = process.env.REACT_APP_API_BASE_URL;



const MillingProfile: React.FC = () => {
  const [userId, setUserId] = useState<number | null>(null);
  const [profile, setProfile] = useState({
    name: "User",
    email: "",
    role: "",
    phone: "",
    profileImage: PredefinedWord.images.profile,
  });

  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const [saving, setSaving] = useState(false);
  const [isEditing, setIsEditing] = useState(false);


  useEffect(() => {
    const token = sessionStorage.getItem("token");

    if (!token) {
      toast.warn("User not logged in");
      return;
    }

    const decoded = decodeToken(token);

    const id = decoded?.sub
      ? parseInt(decoded.sub)
      : decoded?.nameid
        ? parseInt(decoded.nameid)
        : null;

    if (!id) {
      toast.error("User ID not found");
      return;
    }

    setUserId(id);

    fetchUserProfile(id);

  }, []);

  const fetchUserProfile = async (id: number) => {
    const token = sessionStorage.getItem("token");

    try {
      const response = await apiAxios.get(
        `${API_BASE}/Users/GetUser/${id}`,

      );

      const data = response.data;

      setProfile({
        name: data.name || "User",
        email: data.email || "",
        phone: data.mobileNo || "",
        role: data.roleName || "",
        profileImage: data.imageUrl || PredefinedWord.images.profile,
      });
    } catch (error) {
      console.error(error);
      toast.error("Failed to load profile.");
    }
  };
  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      setSelectedFile(file);
      const reader = new FileReader();
      reader.onloadend = () => {
        setProfile((prev) => ({
          ...prev,
          profileImage: reader.result as string,
        }));
      };
      reader.readAsDataURL(file);
    }
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setProfile((prev) => ({ ...prev, [name]: value }));
  };



  const handleSave = async () => {
    if (!userId) return;

    setSaving(true);
    const formData = new FormData();
    formData.append("UserID", userId.toString());
    formData.append("MobileNo", profile.phone);
    if (selectedFile) formData.append("ImagePath", selectedFile);

    const token = sessionStorage.getItem("token");
    try {
      const response = await apiAxios.put(
        `${API_BASE}/Users/UpdateProfile/${userId}`,
        formData,

      );

      toast.success(response.data?.message || "Profile updated successfully!");
      const newImage = response.data.user?.imageUrl;

      setProfile((prev) => ({
        ...prev,
        profileImage: newImage || prev.profileImage,
      }));

      // 🔥 ADD THIS (VERY IMPORTANT)
      if (newImage) {
        sessionStorage.setItem("profileImage", newImage);

        // Notify GenericLayout
        window.dispatchEvent(new Event("profileImageUpdated"));
      }
      setIsEditing(false);
    } catch (err: any) {
      console.error(err);
      toast.error(err.response?.data?.message || "Error updating profile.");
    } finally {
      setSaving(false);
    }
  };


  return (
    <div className="container-fluid mt-2">
      <div className="row">
        {/* --- TOP SECTION --- */}
        <div className="col-md-12">
          <div className="card-topsection-withimage">
            <div className="top-card-section">
              <div className="left-imagesect">
                <img
                  src={profile.profileImage}
                  className="img-fluid custom-profile-image"
                  alt="Profile"
                  onError={(e) => {
                    const target = e.target as HTMLImageElement;
                    target.onerror = null; // ✅ prevent infinite loop
                    target.src = PredefinedWord.images.profile;
                  }}
                />
              </div>

              <div className="right-contentsection">
                <h4 className="user-nameinprofile">{profile.name}</h4>
                <div className="user-relateddetail">
                  <ul className="useldetail-list">
                    <li
                      className="pencil-editicon"
                      onClick={() => setIsEditing(!isEditing)}
                    >
                      <i
                        className={`bi ${isEditing
                          ? "bi bi-check-square edit-icon"
                          : "bi-pencil-square edit-icon"
                          }`}
                      ></i>
                    </li>

                    <li>
                      <div className="content-section">
                        <div className="icon-section">
                          <i className="bi bi-at atthe-rateicon"></i>
                        </div>
                        <div className="text-section">{profile.email}</div>
                      </div>

                      {profile.phone && profile.phone.trim() !== "" && (
                        <div className="content-section">
                          <div className="icon-section">
                            <i className="bi bi-telephone"></i>
                          </div>
                          <div className="text-section mobile-number-section">{profile.phone}</div>
                        </div>
                      )}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* --- BOTTOM SECTION --- */}
        <div className="col-md-12 mt-4">
          <div className="card-topsection-withimage">
            <ul className="bottol-listcontent">
              <li>
                <div className="role-contentpart">
                  <div className="Label-text">Email ID :</div>
                  <div className="user-role-name">
                    <input
                      type="text"
                      name="email"
                      value={profile.email}
                      disabled
                      className="form-control custom-input"
                    />
                  </div>
                </div>
              </li>

              <li>
                <div className="role-contentpart">
                  <div className="Label-text ">Mobile Number :</div>
                  <div className="user-role-name">
                    <input
                      type="text"
                      name="phone"
                      value={profile.phone}
                      disabled
                      className="form-control custom-input disabled"
                    />
                  </div>
                </div>
              </li>

              <li>
                <div className="role-contentpart">
                  <div className="Label-text">Role :</div>
                  <div className="user-role-name">
                    <input
                      type="text"
                      name="role"
                      value={profile.role}
                      disabled
                      className="form-control custom-input"
                    />
                  </div>
                </div>
              </li>

              {isEditing && (
                <li>
                  <div className="role-contentpart">
                    <div className="Label-text">Upload Profile Picture :</div>
                    <div className="user-role-name">
                      <input
                        type="file"
                        name="profileImage"
                        accept="image/*"
                        onChange={handleFileChange}
                        className="form-control-file editable"
                      />
                    </div>
                  </div>
                </li>
              )}

            </ul>

            {/* --- BUTTON SECTION --- */}
            {isEditing && (
               <div className="text-start mx-3 py-3">
                <button
                  className="btn btn-primary"
                  onClick={handleSave}
                  disabled={saving} >
                  {saving ? "Saving..." : "Save Changes"}
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MillingProfile;
